<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px">
  <div fxFlex="50%" fxFlex.xs="100%">
    <div fxLayout="column">
      <form [formGroup]="waiterForm" (ngSubmit)="onSubmit()" class="form-container">
        <mat-form-field class="form-field">
          <input matInput placeholder="Vorname" formControlName="firstName" />
        </mat-form-field>

        <mat-form-field class="form-field">
          <input matInput placeholder="Nachname" formControlName="lastName" />
        </mat-form-field>

        <mat-form-field class="form-field">
          <input matInput placeholder="Straße" formControlName="street" />
        </mat-form-field>

        <mat-form-field class="form-field">
          <input matInput placeholder="Hausnummer" formControlName="houseNumber" />
        </mat-form-field>

        <mat-form-field class="form-field">
          <input matInput placeholder="PLZ" formControlName="zip" />
        </mat-form-field>

        <mat-form-field class="form-field">
          <input matInput placeholder="Stadt" formControlName="city" />
        </mat-form-field>

        <mat-form-field class="form-field">
          <input matInput placeholder="Land" formControlName="country" />
        </mat-form-field>

        <mat-form-field class="form-field">
          <input matInput placeholder="Telefonnummer" formControlName="mobileNumber" />
        </mat-form-field>

        <mat-form-field class="form-field">
          <input matInput placeholder="E-Mail" formControlName="email" />
        </mat-form-field>

        <div class="form-field" *ngIf="superadmin">
          <mat-checkbox formControlName="newTenant">Neue Veranstaltung</mat-checkbox>
        </div>

        <mat-form-field class="form-field" *ngIf="superadmin">
          <input matInput placeholder="Veranstaltungsname" formControlName="tenantName" />
        </mat-form-field>

        <button mat-raised-button color="accent" type="submit" class="submit-button">Kellner erstellen</button>
      </form>
    </div>
  </div>
</div>


<button *ngIf="superadmin" mat-raised-button color="accent" (click)="simulateError()">Fehler simulieren</button>

